import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleTooltip", "subtitle", "content", "approveButton", "cancelButton", "additionalButton", "disclaimer", "align"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { ButtonFilled, ButtonOutline, ButtonSimple } from '@snack-uikit/button';
import { Link } from '@snack-uikit/link';
import { Typography } from '@snack-uikit/typography';
import { ALIGN, TEST_IDS } from '../../constants';
import { getAlignProps, getButtonsSize } from '../../utils';
import { MobileModalCustom } from '../MobileModalCustom';
import styles from "./styles.module.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MobileModal(_ref) {
  var title = _ref.title,
    titleTooltip = _ref.titleTooltip,
    subtitle = _ref.subtitle,
    content = _ref.content,
    approveButton = _ref.approveButton,
    cancelButton = _ref.cancelButton,
    additionalButton = _ref.additionalButton,
    disclaimer = _ref.disclaimer,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? ALIGN.Default : _ref$align,
    rest = _objectWithoutProperties(_ref, _excluded);
  var aligns = getAlignProps({
    align: align
  });
  var buttonsSize = getButtonsSize();
  var needFooter = Boolean(approveButton) || Boolean(cancelButton) || Boolean(additionalButton) || Boolean(disclaimer);
  return /*#__PURE__*/_jsxs(MobileModalCustom, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/_jsx(MobileModalCustom.Header, {
      className: cn(_defineProperty({}, styles.modalHeader, !content)),
      title: title,
      titleTooltip: titleTooltip,
      subtitle: subtitle,
      align: aligns.header
    }), Boolean(content) && /*#__PURE__*/_jsx(MobileModalCustom.Body, {
      className: styles.modalBody,
      content: content,
      align: aligns.body
    }), needFooter && /*#__PURE__*/_jsx(MobileModalCustom.Footer, {
      actions: /*#__PURE__*/_jsxs(_Fragment, {
        children: [approveButton && /*#__PURE__*/_jsx(ButtonFilled, _objectSpread(_objectSpread({
          appearance: "primary"
        }, approveButton), {}, {
          size: buttonsSize,
          className: cn(styles.footerButton, approveButton.className),
          "data-test-id": TEST_IDS.approveButton
        })), cancelButton && /*#__PURE__*/_jsx(ButtonOutline, _objectSpread(_objectSpread({
          appearance: "neutral"
        }, cancelButton), {}, {
          size: buttonsSize,
          className: cn(styles.footerButton, cancelButton.className),
          "data-test-id": TEST_IDS.cancelButton
        })), additionalButton && /*#__PURE__*/_jsx(ButtonSimple, _objectSpread(_objectSpread({
          appearance: "neutral"
        }, additionalButton), {}, {
          size: buttonsSize,
          className: cn(styles.footerButton, additionalButton.className),
          "data-test-id": TEST_IDS.additionalButton
        }))]
      }),
      disclaimer: disclaimer && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Typography.SansBodyS, {
          "data-test-id": TEST_IDS.disclaimerText,
          children: disclaimer.text
        }), disclaimer.link && /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, disclaimer.link), {}, {
          size: "s",
          "data-test-id": TEST_IDS.disclaimerLink
        }))]
      }),
      align: aligns.footer,
      className: styles.modalFooter
    })]
  }));
}